"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStageOneInfo = getStageOneInfo;
exports.opAmpStatus_TIA = opAmpStatus_TIA;
exports.pickOpAmp_TIA = pickOpAmp_TIA;
var _photodiodeConstants = _interopRequireDefault(require("./photodiode-constants"));
var _messages = _interopRequireDefault(require("./messages"));
var _errorCodes = _interopRequireDefault(require("./error-codes"));
var _stages = require("./stages");
var _model = require("./model");
var Solver = _interopRequireWildcard(require("./solver"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//This function picks an op amp out of the recommended list for the TIA stage.   It can be used to figure out the first stage
//in a one or two stage designs.
function pickOpAmp_TIA(stage1Array, userInputs, opAmpDB, needSomeSpeed) {
  var errorObject = {
    errorCode: "",
    errorParameter: {},
    notRecommendedAvailable: false
  };
  let stageOne = getStageOneInfo(stage1Array, userInputs, opAmpDB);

  //do we have some op amps that were recommended?
  if (stageOne.minRecommendedScore < 1e60) return {
    stage1: stageOne.recommended
  };

  //do we allow not recommended op amps?
  else if (stageOne.minAllowedScore < 1e60 && !userInputs.requireRecommended) return {
    stage1: stageOne.allowed
  };

  //everything is either not allowed or not recommended
  else {
    //If there is an allowed solution available, set the flag
    if (stageOne.minAllowedScore < 1e60) {
      errorObject.errorParameter.notRecommendedAvailable = true;
      errorObject.errorParameter.marginalStatusMessage = stageOne.allowed.statusMessage;
    }

    //This error message will be overwritten if software is working correctly.
    errorObject.errorMessage = 'Software error. Stages=' + userInputs.stages + '; needSomeSpeed=' + needSomeSpeed;
    if (userInputs.stages === _photodiodeConstants.default.pdStages.oneStage && needSomeSpeed >= 0) {
      errorObject.errorCode = _errorCodes.default.noOpAmpAvailableForSingleStageTooFast;
    }
    if (userInputs.stages === _photodiodeConstants.default.pdStages.oneStage && needSomeSpeed < 0) {
      errorObject.errorCode = _errorCodes.default.noOpAmpAvailableForSingleStageTooSlow;
    }
    if (userInputs.stages === _photodiodeConstants.default.pdStages.twoStage && needSomeSpeed >= 0) {
      errorObject.errorCode = _errorCodes.default.noOpAmpAvailableForFirstStageTooFast;
    }
    if (userInputs.stages === _photodiodeConstants.default.pdStages.twoStage && needSomeSpeed < 0) {
      errorObject.errorCode = _errorCodes.default.noOpAmpAvailableForFirstStageTooSlow;
    }
    return (0, _model.setModelError)(errorObject);
  }
}

//This function determines whether the TIA op amp is recommended, allowed, or not allowed
function opAmpStatus_TIA(stage1, userInputs) {
  var cf = stage1.cf;
  var cfext = stage1.cfext;
  var bw = stage1.bw;
  var rf = stage1.rf;
  var Q = stage1.q;
  var opAmpObject = stage1.opAmp;
  var notAllowedString = [];
  var allowedString = [];
  var status = _photodiodeConstants.default.opAmpStatus.recommended;
  var statusMessage = [];
  var maxOpAmpOutput;
  var minSlewRate;
  var needFaster = 0; //helps us know what kind of error message to give user if no recommended op amps are found - if positive number, user needs faster op amp than we have

  var stage1peakVoltage = rf * userInputs.peakCurrent; //calculate peak voltage this way in case there are two stages 

  //Get max output swing
  //Check input headroom to see if user can use in single supply operation
  if (userInputs.biasPreference === _photodiodeConstants.default.biasPreferenceOptions.positive && userInputs.stages === _photodiodeConstants.default.pdStages.oneStage) {
    //output swings negative to user's peak voltage
    if (opAmpObject.inHeadroomPlus > 0) maxOpAmpOutput = opAmpObject.maxSupplyVoltage / 2 - opAmpObject.outHeadroomMinus;else maxOpAmpOutput = opAmpObject.maxSupplyVoltage - opAmpObject.outHeadroomMinus;
  } else {
    //output swings positive to user's peak voltage
    if (opAmpObject.inHeadroomMinus > 0) maxOpAmpOutput = opAmpObject.maxSupplyVoltage / 2 - opAmpObject.outHeadroomPlus;else maxOpAmpOutput = opAmpObject.maxSupplyVoltage - opAmpObject.outHeadroomPlus;
  }

  /************************* Allowed Checks ********************************/
  //Do the allowed checks first, so that if the op amp is found to be not allowed below, the allowed status will be overwritten.

  //check if op amp is too fast, but if user's application is really slow, than we relax requirement with the bwModifier variable
  var bwModifier = Math.max(15000 / userInputs.speed, 1);
  if (bw > 10 * userInputs.speed * bwModifier) {
    status = _photodiodeConstants.default.opAmpStatus.allowed;
    allowedString.push({
      key: _messages.default.amp_status_too_fast
    }); // "too fast; "
    needFaster = -1;
  }

  //check if cf is so small that board parasitics will have big impact           
  if (userInputs.speed > 1e6) {
    if (cf < 50e-15) {
      status = _photodiodeConstants.default.opAmpStatus.allowed;
      allowedString.push({
        key: _messages.default.amp_status_cf_less_50fF
      }); //" Cf < 50fF; "
    }
  } else {
    if (cf < 100e-15) {
      status = _photodiodeConstants.default.opAmpStatus.allowed;
      allowedString.push({
        key: _messages.default.amp_status_cf_less_100fF
      }); //" Cf < 0.1pF; "
    }
  }
  var biasCurrent = opAmpObject.iBias;
  // var userGain = userInputs.peakCurrent

  //Bias Current Limit:
  //1 kHz: 100pA, 10 kHz: 100pA, 100 kHz: 100pA, 1MHz: 50nA, 10MHz: 50uA, 100MHz, 50mA
  var biasLimit = Math.max(100e-12, 50e-27 * userInputs.speed * userInputs.speed * userInputs.speed);
  //But anything that creates less than 800 uV output offset is fine
  biasLimit = Math.max(biasLimit, 800e-6 / rf);
  //And make sure our biasLimit is no more than the user's input current
  biasLimit = Math.min(biasLimit, userInputs.peakCurrent);
  if (biasCurrent > biasLimit) {
    status = _photodiodeConstants.default.opAmpStatus.allowed;
    allowedString.push({
      key: _messages.default.amp_status_bias_current_is,
      data: biasCurrent
    }); //"High output offset (bias current is ___A);"
  }

  //Precision folks don't normally like zero-drift parts since they have a lot of noise
  if (opAmpObject.architecture && opAmpObject.architecture.indexOf("Zero Drift") > -1) {
    status = _photodiodeConstants.default.opAmpStatus.allowed;
    allowedString.push({
      key: _messages.default.amp_status_zero_drift
    }); //"zero drift;"
  }

  //We allow bandwidth slightly less than requested
  if (bw < 0.8 * userInputs.speed && userInputs.speed <= 1e6 || bw < 0.6 * userInputs.speed && userInputs.speed > 1e6) {
    status = _photodiodeConstants.default.opAmpStatus.allowed;
    allowedString.push({
      key: _messages.default.amp_status_not_fast_enough
    }); // "not fast enough; ";
    needFaster = 1;
  }

  //check for really big offset op amps
  var stage1maxVoltage = rf * userInputs.peakCurrent;
  if (opAmpObject.vos > 0.5 * stage1maxVoltage) {
    status = _photodiodeConstants.default.opAmpStatus.allowed;
    allowedString.push({
      key: _messages.default.amp_status_high_vos,
      data: opAmpObject.vos
    }); //"High output offset (input Vos is ___V);";
  }

  //make sure to allow for peaking in slew rate.   
  minSlewRate = Math.PI * 2 * userInputs.speed * stage1peakVoltage / 2 * Q;
  if (opAmpObject.slewRate * 1e6 < minSlewRate && status === _photodiodeConstants.default.opAmpStatus.recommended) {
    status = _photodiodeConstants.default.opAmpStatus.allowed;
    allowedString.push({
      key: _messages.default.amp_status_slew_rate_marginal
    }); //"slew rate marginal; "
  }

  //Check if 2nd stage will require a really big gain
  if (userInputs.stages === _photodiodeConstants.default.pdStages.twoStage) {
    var totalGain = userInputs.peakVoltage / userInputs.peakCurrent;
    var secondStageGain = totalGain / rf;
    if (secondStageGain > 50) {
      status = _photodiodeConstants.default.opAmpStatus.allowed;
      allowedString.push({
        key: _messages.default.amp_status_big_2nd_stage_gain,
        data: secondStageGain
      }); //"Requires 2nd stage gain of __;"
    }
  }

  //AD8634 is a super expensive, high temp amp.   We want in the tool in case the high temp guys want it, but don't want
  //to recommend.   (In reality, given its 200 nA bias current, highly unlikely to be used as photodiode amp, but just in case
  if (opAmpObject.partNumber === "AD8634") {
    status = _photodiodeConstants.default.opAmpStatus.allowed;
    allowedString.push({
      key: _messages.default.amp_status_specialty_amp
    }); //"specialty amplifier; "
  }

  //Harry Holt made a strong case for not allowing quad op amps for the following reasons:
  //- layout is more difficult, so the parasitic capacitance is likely higher
  //- self heating will increase bias current for JFET's and Mosfets (used example of AD8513: 3mA * 30V * 4
  //- potential crosstalk
  if (opAmpObject.numberChannels === 4) {
    status = _photodiodeConstants.default.opAmpStatus.allowed;
    allowedString.push({
      key: _messages.default.amp_status_quad
    });
  }

  // If status is Not Recommended for New Designs or Last Time Buy, you need to make this allowed
  // instead of recommended
  if (opAmpObject.deviceStatus === 4) {
    status = _photodiodeConstants.default.opAmpStatus.allowed;
    allowedString.push({
      key: _messages.default.amp_status_not_recommended_for_new_designs
    });
  } else if (opAmpObject.deviceStatus === 5) {
    status = _photodiodeConstants.default.opAmpStatus.allowed;
    allowedString.push({
      key: _messages.default.amp_status_last_time_buy
    });
  }

  /*********************** Not Allowed Checks *************************/
  //Prevent any cf's below zero
  if (cf <= 0) {
    //some op amps just too slow
    if (opAmpObject.gbw !== null && userInputs.speed > opAmpObject.gbw) {
      status = _photodiodeConstants.default.opAmpStatus.notAllowed;
      notAllowedString.push({
        key: _messages.default.amp_status_not_fast_enough
      }); // "not fast enough; ";
    }
    //but others borderline.  Fail in higher Q situations
    else {
      status = _photodiodeConstants.default.opAmpStatus.notAllowed;
      notAllowedString.push({
        key: _messages.default.amp_status_not_enough_peaking
      });
    }
  } else {
    //for cases where cf is still above zero but becomes negative due to the internal feedback capacitance
    if (cfext < 0) {
      status = _photodiodeConstants.default.opAmpStatus.notAllowed;
      notAllowedString.push({
        key: _messages.default.amp_status_internal_cf_too_high
      });
    }
    //check if anything else is wrong - likely indicates somebody left an input capacitance in "F" in PDB rather than "pF"
    if (isNaN(bw) || isNaN(cf) || isNaN(rf)) {
      status = _photodiodeConstants.default.opAmpStatus.notAllowed;
      notAllowedString.push({
        key: _messages.default.amp_status_dB_error
      });
    }
    //Make sure bandwidth is high enough.  Put this in the cf<=0 else statement so that we don't generate two "not fast enough" errors
    else if (bw < 0.5 * userInputs.speed && userInputs.speed <= 1e6 || bw < 0.2 * userInputs.speed && userInputs.speed > 1e6) {
      status = _photodiodeConstants.default.opAmpStatus.notAllowed;
      notAllowedString.push({
        key: _messages.default.amp_status_not_fast_enough
      }); // "not fast enough; ";
    }
  }

  //check if bandwidth will be way over what user wanted
  if (bw > 100 * userInputs.speed * bwModifier) {
    status = _photodiodeConstants.default.opAmpStatus.notAllowed;
    notAllowedString.push({
      key: _messages.default.amp_status_too_fast
    }); // "too fast; "
  }

  //check voltage range
  if (stage1peakVoltage > maxOpAmpOutput) {
    status = _photodiodeConstants.default.opAmpStatus.notAllowed;
    notAllowedString.push({
      key: _messages.default.amp_status_voltage_not_enough
    }); //"voltage range not enough for peak output voltage; ";
  }

  //if under 5 MHz, disallow parts with biasCurrent triple user's input current
  if (userInputs.speed < 5e6 && biasCurrent > 3 * userInputs.peakCurrent) {
    status = _photodiodeConstants.default.opAmpStatus.notAllowed;
    notAllowedString.push({
      key: _messages.default.amp_status_bias_current_is,
      data: biasCurrent
    }); //"High output offset (bias current is ___A);"
  }

  //if 2nd stage needs huge gain, disallow
  if (userInputs.stages === _photodiodeConstants.default.pdStages.twoStage) {
    totalGain = userInputs.peakVoltage / userInputs.peakCurrent;
    secondStageGain = totalGain / rf;
    if (secondStageGain > 150) {
      status = _photodiodeConstants.default.opAmpStatus.notAllowed;
      notAllowedString.push({
        key: _messages.default.amp_status_big_2nd_stage_gain,
        data: secondStageGain
      }); //"Requires 2nd stage gain of __;"
    }
  }

  //disallow parts that require gains more than 1
  if (opAmpObject.minStableGain !== "1" && !(opAmpObject.partNumber !== "AD8067" || opAmpObject.partNumber !== "AD8099")) {
    status = _photodiodeConstants.default.opAmpStatus.notAllowed;
    notAllowedString.push({
      key: _messages.default.amp_status_min_stable_gain,
      data: opAmpObject.minStableGain
    }); //"Min stable gain = __;"
  }

  //Check if rf is too small
  if (opAmpObject.feedbackMethod === "Current") {
    if (rf < 0.8 * opAmpObject.cfb.minRf) {
      status = _photodiodeConstants.default.opAmpStatus.notAllowed;
      notAllowedString.push({
        key: _messages.default.amp_status_cfb_rf_too_small
      });
    }
  }
  //if voltage feedback, output resistance can cause excessive peaking that throws our Q and fp calculations (see JIRA PD-653)
  else {
    if (rf * 1.5 < opAmpObject.rOut) {
      status = _photodiodeConstants.default.opAmpStatus.notAllowed;
      notAllowedString.push({
        key: _messages.default.amp_status_cfb_rf_too_small
      });
    }
  }

  //only check for slew rate if we haven't failed already (if op amp not fast enough, telling user slew rate is also no good is redundant)
  minSlewRate = minSlewRate * 0.8; //Allow slightly marginal slew rates
  if (minSlewRate > opAmpObject.slewRate * 1e6 && status !== _photodiodeConstants.default.opAmpStatus.notAllowed) {
    status = _photodiodeConstants.default.opAmpStatus.notAllowed;
    notAllowedString.push({
      key: _messages.default.amp_status_slew_rate_low
    }); //"slew rate too low; ";
  }

  // If status is Obsolete, the op amp becomes not allowed
  if (opAmpObject.deviceStatus === 6) {
    status = _photodiodeConstants.default.opAmpStatus.notAllowed;
    notAllowedString.push({
      key: _messages.default.amp_status_obsolete
    });
  }
  if (status === _photodiodeConstants.default.opAmpStatus.notAllowed) statusMessage = notAllowedString; //remove last semicolon and space
  else if (status === _photodiodeConstants.default.opAmpStatus.allowed) {
    statusMessage = allowedString; //allowedString.substring(0, allowedString.length - 2);   //remove last semicolon and space
  }
  return {
    status: status,
    statusMessage: statusMessage,
    minSlewRate: minSlewRate,
    needFaster: needFaster
  };
}
function getStageOneInfo(stage1Array, userInputs, opAmpDB) {
  var debugArray = [],
    minRecommendedScore = 1e60,
    minAllowedScore = 1e60,
    recommended = null,
    allowed = null;
  for (var i = 0; i < stage1Array.length; i++) {
    if (stage1Array[i].status !== _photodiodeConstants.default.opAmpStatus.notAllowed) {
      var noiseScore = noiseScore_TIA(stage1Array[i], userInputs, opAmpDB[i]);
      var dcScore = dcScore_TIA(stage1Array[i], userInputs, opAmpDB[i]);
      var bwScore = bwScore_TIA(stage1Array[i], userInputs, opAmpDB[i]);
      var stage2Score = stage2Score_TIA(stage1Array[i], userInputs, opAmpDB[i]);
      var numberScore = singleDualQuadScore(stage1Array[i], userInputs, opAmpDB[i]);
      var totalScore = noiseScore + dcScore + bwScore + stage2Score + numberScore;
      debugArray.push({
        opAmpName: stage1Array[i].opAmpName,
        noiseScore: noiseScore,
        dcScore: dcScore,
        bwScore: bwScore,
        totalScore: totalScore
      });
      if (stage1Array[i].status === _photodiodeConstants.default.opAmpStatus.recommended && totalScore < minRecommendedScore) {
        minRecommendedScore = totalScore;
        recommended = stage1Array[i];
      } else if (stage1Array[i].status === _photodiodeConstants.default.opAmpStatus.allowed && totalScore < minAllowedScore) {
        minAllowedScore = totalScore;
        allowed = stage1Array[i];
      }
    }
  }
  return {
    recommended: recommended,
    allowed: allowed,
    minRecommendedScore: minRecommendedScore,
    minAllowedScore: minAllowedScore
  };
}
function noiseScore_TIA(stage1Info, userInputs, opAmpObject) {
  "use strict";

  var capGain = capGainCalculate(stage1Info, userInputs, opAmpObject);
  var vNoise = opAmpObject.vNoise * capGain;
  var iNoise = opAmpObject.iNoise * stage1Info.rf;
  var sumVNoiseandINoise = Math.sqrt(vNoise * vNoise + iNoise * iNoise);

  //2nd stage may have some more gain, so we account for that here
  var ifOnlyOneStageResistor = userInputs.peakVoltage / userInputs.peakCurrent;
  var resNoise = Math.sqrt(ifOnlyOneStageResistor / 1000) * 4e-9;
  var secondStageGain = ifOnlyOneStageResistor / stage1Info.rf;
  var score = sumVNoiseandINoise * secondStageGain / resNoise;

  //scaling factor
  score = score * 0.33;
  return score;
}
function bwScore_TIA(stage1Info, userInputs) {
  var score = userInputs.speed / stage1Info.bw;
  if (score < 1) {
    //Don't penalize higher than user's bandwith (noise and offset should do this for us)
    score = 1;
  }
  return score;
}
function dcScore_TIA(stage1, userInputs, opAmpObject) {
  let stage2;
  if (userInputs.stages === _photodiodeConstants.default.pdStages.twoStage) {
    //This is a kluge to try to get some idea of how much dc error the 2nd stage will contribute.  We reuse the same amplifier
    //from stage 1, since we don't know yet what the stage 2 amplifier will be.   It isn't perfect, but does a reasonable job
    //penalizing designs with a high gain in the second stage
    stage2 = (0, _stages.stage2Info)(userInputs, opAmpObject, stage1.opAmp);
  } else {
    stage2 = null;
  }
  var stagesObject = {
    stage1: stage1,
    stage2: stage2
  };
  var dcError = Solver.calculateOutputOffset(stagesObject);

  //dc error matters less at higher peak voltages and higher frequencies, so scale appropriately
  var score = 150000 * dcError / Math.sqrt(userInputs.peakVoltage * userInputs.speed);
  return score;
}
function capGainCalculate(stage1Info, userInputs, opAmpObject) {
  var cDiff = opAmpObject.cDiff;
  var cCm = opAmpObject.cCm;
  var cIn = cDiff + cCm + userInputs.capacitance;
  var capGain = 1 + cIn / stage1Info.cf;
  return capGain;
}

//If it's a two stage design, and the op amp can't be reused in the 2nd stage, it gets a worse score
//Lower scores are better
function stage2Score_TIA(stage1Info, userInputs, opAmpObject) {
  var score = 0;
  if (userInputs.stages === _photodiodeConstants.default.pdStages.twoStage) {
    var maxOpAmpOutput = opAmpObject.maxSupplyVoltage / 2 - opAmpObject.outHeadroomPlus;
    var minSlewRate = Math.PI * 2 * userInputs.speed * userInputs.peakVoltage / 2;
    if (userInputs.peakVoltage > maxOpAmpOutput) {
      score = 3;
    }
    if (minSlewRate > opAmpObject.slewRate * 1e6) {
      score = 3;
    }
  }
  return score;
}

//This function gives a very slight edge to a single op amp in a single stage design and a dual op amp in a dual stage design
function singleDualQuadScore(stage1info, userInputs, opAmpObject) {
  var numChannels = parseInt(opAmpObject.numberChannels),
    score;
  if (userInputs.stages === _photodiodeConstants.default.pdStages.pdStages) {
    score = 0.01 * numChannels;
  } else {
    if (numChannels === 2) score = 0.01;else if (numChannels === 1) score = 0.02;else score = 0.04;
  }
  return score;
}